import { array, bool, func, oneOf, string } from 'prop-types'
import Filter from '../../Filter'
import WrappedFilterBrowser from './wrapped'

// @note `item` must always be the final parameter because of how this function
//   is called.
const renderItem = (
  value,
  onFilterSelect,
  onFilterRemove,
  onPathChange,
  currentPath,
  highlightedFilterId,
  onFilterMouseMove,
  theme,
  item
) => {
  const common = {
    highlighted: item.id === highlightedFilterId,
    key: item.id,
    onMouseMove: onFilterMouseMove,
    theme,
  }
  if (item.childOptions && item.childOptions.length) {
    const expander = onPathChange.bind(this, [...currentPath, item.id])
    return (
      <Filter
        {...common}
        isExpandable={true}
        onClick={expander}
        onExpand={expander}
        {...item}
      />
    )
  }

  if (item.divider) {
    return <Filter {...common} {...item} />
  }

  if (value && value.includes(item.id)) {
    const remover = onFilterRemove.bind(this, item.id)
    return (
      <Filter
        {...common}
        isRemovable={true}
        onClick={remover}
        onRemove={remover}
        selected={true}
        {...item}
      />
    )
  }

  const adder = onFilterSelect.bind(this, { id: item.id, disabled: false })
  return (
    <Filter
      {...common}
      isAddable={true}
      onClick={adder}
      onAdd={adder}
      {...item}
    />
  )
}

const FilterBrowser = ({
  currentPath,
  highlightedFilterId,
  loading,
  onFilterMouseMove,
  onFilterRemove,
  onFilterSelect,
  onPathChange,
  theme = 'light',
  value,
  ...otherProps
}) => {
  const renderer = renderItem.bind(
    this,
    value,
    onFilterSelect,
    onFilterRemove,
    onPathChange,
    currentPath,
    highlightedFilterId,
    onFilterMouseMove,
    theme
  )
  return (
    <WrappedFilterBrowser
      currentPath={currentPath}
      highlightedFilterId={highlightedFilterId}
      loading={loading}
      onFilterMouseMove={onFilterMouseMove}
      onPathChange={onPathChange}
      renderer={renderer}
      theme={theme}
      value={value}
      {...otherProps}
    />
  )
}
FilterBrowser.displayName = 'Kuiper: FilterBrowser ← SearchResults ← FilterBar '

FilterBrowser.propTypes = {
  currentPath: array,
  highlightedFilterId: string,
  loading: bool,
  onFilterMouseMove: func,
  onFilterRemove: func,
  onFilterSelect: func,
  onPathChange: func,
  theme: oneOf(['dark', 'light']),
  value: array,
}

export default FilterBrowser
